import { useQuery } from '@tanstack/react-query'
import useAPIService from "@hooks/useAPIService";
import log from "loglevel";


type DetailsQueryType = (
) => any;

const usePreAuthURL: DetailsQueryType = (
) => {
  //const [transactions, setTransactions] = useState<Transaction[]>([]);
  const apiService  = useAPIService();

  log.debug("getPreAuthURL invoked");

  return useQuery({
    queryKey:['preauthd'], 
    queryFn: async () => 
      apiService.fetch("getPreAuthURL", {})
      .then((data: any) => {
          log.debug("Preauth response:", data);
          return data.verified_url;
        })
      .catch(function (error) {
        log.warn("fetch error:" + error);
      }),
      refetchInterval: false,           // ⬅️ disable polling
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,            // if cache has data, don’t refetch on remount
      staleTime: Infinity,              // data never becomes stale
      retry: false,     
    })
}

export default usePreAuthURL;
